
/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import { Message } from 'element-ui'
import store from './store'
import * as types from './store/mutation-types'

// 超时时间
axios.defaults.timeout = 11e3
// http请求拦截器
axios.interceptors.request.use(config => {
  //判断浏览器是否为IE，若是，则在url上拼接时间参数
  let UA = window.navigator.userAgent.toLowerCase();
  let isIE = UA && /msie|trident/.test(UA);
  if(isIE) {
    if(config.url.indexOf("?") > -1) {
      config.url = config.url + '&t='+ Date.now()
    }else {
      config.url = config.url + '?t='+ Date.now()
    }
  }
  return config
}, error => {
  Message.error('请求超时')
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(data => {// 响应成功关闭loading
  
  switch (data.data.code) {
    case 80000:
    case 80001:
    case 80003:
    case 90000:
      // alert(JSON.stringify(data.data))
      // store.dispatch('logout')
      store.commit(types.LOGOUT)
      location.href = Url[Mode].memberUrl+'/login?jump='+ Base64.encode(location.href)
      return data
      break
    case 30006:
      return data
      break
    case 0:
      return data
      break
    default:
      return data
      break
  }
}, error => {
  Message.error({
    message: '加载失败'
  })
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./app/interceptor.js